import ReactDOM from 'react-dom'

import 'assets/styles/main.less'
import 'assets/favicons'

import App from './app/Application'

// Before React renders the application we need to include the MUI license.
// This removes the watermarks from the MUI Pro components and keeps
// us compliant with the license.
import './utils/mui-license'

// Quick hack to load the supported Moment languages in Vite.
// Necessary because The ES bundle of moment doesn't load every locale by default.
// This has no affects on the production bundle, and when using Webpack.
if (__VITE__) {
  // @ts-ignore
  import('moment/dist/locale/en-gb')
  // @ts-ignore
  import('moment/dist/locale/nl')
  // @ts-ignore
  import('moment/dist/locale/fr')
  // @ts-ignore
  import('moment/dist/locale/de')
}

// if the browser (the browser checker) could not be loaded. render the app anyway.
if (!bowser || bowser.isBowserSupportedByGMS()) {
  ReactDOM.render(<App />, document.getElementById('root'))
}
